import React from 'react';
import { Box, Typography, Button, CircularProgress } from '@mui/material';
import { radius, elevation } from '../../themes/smartinventoryTheme';

// Sticks to the bottom of a form page only while there are unsaved changes —
// My Company and Profile both need this, so it lives here once rather than
// being re-implemented per page. Discard resets the form back to its
// last-loaded values; Save posts the change.
const SaveBar = ({ dirty, saving, message, discardLabel, saveLabel, onDiscard, onSave }) => {
  if (!dirty) return null;

  return (
    <Box
      sx={{
        position: 'sticky',
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 2,
        mt: 3,
        p: 2,
        borderRadius: `${radius.lg}px`,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        boxShadow: elevation.overlay,
      }}
    >
      <Typography variant="body2" color="text.secondary">{message}</Typography>
      <Box sx={{ display: 'flex', gap: 1.25 }}>
        <Button variant="text" onClick={onDiscard} disabled={saving}>{discardLabel}</Button>
        <Button
          variant="contained"
          onClick={onSave}
          disabled={saving}
          startIcon={saving ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {saveLabel}
        </Button>
      </Box>
    </Box>
  );
};

export default SaveBar;
